export interface IAnswer {
    id: string;
    text: string;
    isAnswered?: boolean;
    isCorrect: boolean;
    createdAt: Date;
    order: number;
}

export interface IQuestion {
    id: string;
    question: string;
    isQuestionReady: boolean;
    isImageReady: boolean;
    hint?: string;
    imageUrl?: string;
    image?: string;
    completionDate?: Date | null;
    isFreePlan?: boolean;
    isHidden?: boolean;
    isSaved?: boolean;
    isUnknown?: boolean;
    order: number;
    state: string;  // Format NJ|NY|FL|CL
    vehicleType: string;  // Format Car|Motorcycle|CDL
    isRandom: boolean;
    createdAt: Date;
    source?: string;
    answers: IAnswer[]
}

export interface Test {
    id: string;
    title: string;
    imageUrl?: string;
    image?: string;
    isCompleted?: boolean;
    isFreePlan?: boolean;
    order: number;
    createdAt: Date;
    questions: IQuestion[];
}

export interface TestGroup {
    id: string;
    title: string;
    groupType: string;
    imageUrl?: string;
    image?: string;
    isCompleted?: boolean;
    order: number;
    createdAt: Date;
    tests: Test[];
}

interface CreateNewState {
    isLoading: boolean;
    testGroups: TestGroup[];
    testGroupsProd: TestGroup[];
    testGroupsDev: TestGroup[];
    tests: Test[];
}

export const initialState: CreateNewState = {
    isLoading: false,
    testGroups: [],
    testGroupsProd: [],
    testGroupsDev: [],
    tests: [],
}